<template>
  <div style="min-width: 575px;">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === "" && Object.keys(formulario).length >= 1'>
      <div class="contratosConfigCom">
        <RF-Formulario :data-time='time' class="contratosConfigCom-form"
          :cpntTime='time'
          :cpntId='formulario.id' 
          :cpntStatus='formulario.status'
          :cpntField='formulario.field'
          :cpntUltAlt='formulario.ult_alt'
          :cpntButtons='formulario.buttons'
          :cpntTabIndexFieldGeral='formulario.tabIndexFieldGeral'
          :cpntTabIndexButtonGeral='formulario.tabIndexButtonGeral'

          :ref='formulario.id'
        ></RF-Formulario>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .contratosConfigCom {
    width: 575px;
  }
    .contratosConfigCom-form {
      padding-top: 20px;
    }
</style>

<style>
</style>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario: {}
      }
    },
    mounted: function () {
      this.contratosConfigComIniciar()
    },
    methods: {
      contratosConfigComIniciar: function () {
        // SETA O STATUS GERAL
        this.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
        this.contratosConfigComFormularioIniciar()
      },
      contratosConfigComFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'form-contato',
          focus: '',
          field: {}
          // tabIndexFieldGeral: 210001,
          // tabIndexButtonGeral: 210002
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.formulario.field = {
          ambiente: {
            tipo: 'select2',
            tamanho: 3,
            nome: 'Ambiente',
            optionInicialNome: '',
            options: [
              { id: 'h', nome: 'Homologação' },
              { id: 'p', nome: 'Produção' }
            ],
            apiEnv: 'ambiente',
            apiRec: 'ambiente',
            keyMostra: [ 'nome' ],
            keyValue: 'id',
            onChange: self.contratosConfigComOnChangeValue
          },
          token: {
            tipo: 'input',
            tamanho: 70,
            nome: 'Token',
            mostrar: false,
            apiEnv: 'token',
            apiRec: 'token',
            onChange: self.contratosConfigComOnChangeValue
          },
          cripto: {
            tipo: 'input',
            tamanho: 70,
            nome: 'Cripto',
            mostrar: false,
            apiEnv: 'crypt_key',
            apiRec: 'crypt_key',
            onChange: self.contratosConfigComOnChangeValue
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.comunicaAPI('/contrato/config/d4sign/credencial/get', 'GET', null, function (apiSuccess) {
            self.$store.state.FUN_API_RET_SET_VALUE(self.formulario, apiSuccess.data, function (form) {
              // SETA OS CAMPOS RECEBIDOS
              self.formulario = form

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
              self.contratosConfigComFinalizarForm()
            })
          }, function (apiError) {
            self.contratosConfigComSetaErroAPi(apiError)
          })
        })
      },
      contratosConfigComFinalizarForm: function () {
        var self = this

        self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
          env: self.contratosConfigComEnviarAPi
        }, function (buttons) {
          buttons.env.texto = 'Salvar'

          // CRIA OS BUTTONS DO FORMULARIO
          self.formulario.buttons = buttons

          // SETA O STATUS PARA O FORMULARIO
          self.formulario.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA O STATUS GERAL
          self.statusGeral = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA VERIFICAR O CAMPO QUE DEVE SER APRESENTADO
          self.contratosConfigComVerificaCampoMostra()
        })
      },
      contratosConfigComVerificaCampoMostra: function () {
        switch (this.formulario.field.ambiente.value) {
          case '':
            this.formulario.field.token.mostrar = false
            this.formulario.field.cripto.mostrar = false
            break

          case 'h':
          case 'p':
            this.formulario.field.token.mostrar = true
            this.formulario.field.cripto.mostrar = true
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      },
      contratosConfigComEnviarAPi: function () {
        var self = this

        // SETA O STATUS DO BUTTON
        self.formulario.buttons.env.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // MONTA O FORMULARIO PARA ENVIO A API
        self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario.field, {}, function (formData) {
          self.$store.state.comunicaAPI('/contrato/config/d4sign/credencial', 'PUT', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // SETA O STATUS DO BUTTON
              self.formulario.buttons.env.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA REINICIAR
              self.contratosConfigComIniciar()
            })
          }, function (apiError) {
            self.contratosConfigComSetaErroAPi(apiError)
          }, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (form, focus) {
              // SETA OS CAMPOS COM OS ERROS
              self.formulario.field = form

              // SETA O CAMPO QUE RECEBE O FOCUS
              self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', focus, false)

              // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.formulario.buttons.env.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        }, false)
      },
      contratosConfigComOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this.formulario.id.length + 1), id.length)

        // SETA O VALOR RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index) {
          case 'ambiente':
            // CHAMA A FUNÇÃO PARA VERIFICAR O CAMPO QUE DEVE SER APRESENTADO
            this.contratosConfigComVerificaCampoMostra()
            break
        }
      },
      contratosConfigComSetaErroAPi: function (apiError) {
        // SETA O STATUS PARA O FORMULARIO
        this.statusGeral = apiError

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
